/* import axios from 'axios' */
import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodas() {
        return axiosJwt.get(`${api}/rm/certidoes`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPorFornecedor(codCfo) {
        return axiosJwt.get(`${api}/rm/certidoes/${codCfo}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarCertidoesPorFornecedor(codCfo) {
        return axiosJwt.post(`${api}/rm/certidoes/${codCfo}/atualizar`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    }
}
